export const AccountViewId = 'account'
